module.exports = __webpack_public_path__ + "img/kr-product-card3-item2-step1.68be0b6.png";